import { render, staticRenderFns } from "./automatically.vue?vue&type=template&id=d1394f4e&scoped=true"
import script from "./automatically.vue?vue&type=script&lang=js"
export * from "./automatically.vue?vue&type=script&lang=js"
import style0 from "./automatically.vue?vue&type=style&index=0&id=d1394f4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1394f4e",
  null
  
)

export default component.exports